import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=24fb2bcd&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=24fb2bcd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb2bcd",
  null
  
)

export default component.exports